import { Button, MagellanPopup } from 'components/atoms';
import CreatedWithAiSelectCard from 'components/molecules/card/created-with-ai-select/CreatedWithAiSelectCard';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Popup from 'reactjs-popup';
import { PopupActions } from 'reactjs-popup/dist/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

interface ICreatedWithAiSelectPopupFormProps {
  trigger?: JSX.Element | ((isOpen: boolean) => JSX.Element) | undefined;
  onSelectCreatedWithAi?: (createdWithAi: boolean | null, actions: PopupActions) => void;
  open?: boolean;
  initialCreatedWithAi?: boolean | null;
  displayMode?: boolean;
}

const CreatedWithAiSelectPopupForm = ({
  trigger,
  onSelectCreatedWithAi,
  open,
  initialCreatedWithAi = null,
  displayMode,
}: ICreatedWithAiSelectPopupFormProps) => {
  const popupRef = useRef<PopupActions | null>(null);
  const { t } = useTranslation();

  const [selectedCreatedWithAi, setSelectedCreatedWithAi] = useState<boolean | null>(null);

  return displayMode ? (
    <>{trigger}</>
  ) : (
    <Popup
      ref={popupRef}
      open={open}
      onOpen={() => {
        setSelectedCreatedWithAi(initialCreatedWithAi);
      }}
      onClose={() => {
        setSelectedCreatedWithAi(null);
      }}
      modal
      nested
      trigger={trigger}
    >
      <MagellanPopup>
        <MagellanPopup.Header>{t('input.label.createdWithAi')}</MagellanPopup.Header>

        <div className="flex flex-col w-full max-w-96 overflow-auto h-[450px] [scrollbar-width:none]  gap-2">
          {[false, true].map((createdWithAi) => (
            <CreatedWithAiSelectCard
              key={String(createdWithAi)}
              createdWithAi={createdWithAi}
              isSelected={selectedCreatedWithAi === createdWithAi}
              onClick={(newCreatedWithAi) =>
                setSelectedCreatedWithAi((prev) =>
                  prev === newCreatedWithAi ? null : newCreatedWithAi,
                )
              }
            />
          ))}
        </div>
        <div className="flex justify-between w-full">
          <Button isClear onClick={() => popupRef.current?.close()}>
            <Button.Text text={t('button.cancel')} />
          </Button>
          <Button
            variant={BUTTON_VARIANT.submit}
            onClick={() =>
              popupRef.current &&
              onSelectCreatedWithAi &&
              onSelectCreatedWithAi(selectedCreatedWithAi, popupRef.current)
            }
          >
            <Button.Text text={t('button.save')} />
          </Button>
        </div>
      </MagellanPopup>
    </Popup>
  );
};

export default CreatedWithAiSelectPopupForm;
